import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/limpidco.webp';
import screenshot_target from '../../../images/letterfunnel/jasparroos.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Jaspar Roos"
      firstname="Jaspar"
      companyname="Limpid & Co"
      competition="InContext en Xebia"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/jasparroos.js